import { BillingProfile } from './billing'
import { Category, MenuItem, MenuItemCategory } from './menu'
import { Message } from './message'
import { Order, OrderItem } from './order'
import { CustomerEvent, Reviews } from './reporting'
import { Reservation } from './reservation'
import { Table, TableCombination, TableSubscriber, TableToken } from './room-plan'
import { Settings } from './settings'
import { Company } from './tenant'
import { User, UserCredentials } from './user'

export const entities = [
	BillingProfile,
	Category,
	MenuItem,
	MenuItemCategory,
	Message,
	Order,
	OrderItem,
	CustomerEvent,
	Reviews,
	Reservation,
	Table,
	TableCombination,
	TableSubscriber,
	TableToken,
	Settings,
	Company,
	User,
	UserCredentials,
]
